
import { useCallback, useEffect, useState } from "react";
import { Avatar, Box, Checkbox, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { separadorMillares, useDebounce, usePrecioCarritoXRole } from "../../../hooks";
import { TextFormField, TextFormNumber } from "../../components";
import { editarValorItemCarrito, modificarNombreCotizacion } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { useGlobalValueStore } from "../../../stores";


const baseUrl = process.env.REACT_APP_API_URL;



export const TablaCotizacionEditar = ({ data, selected, handleClick }) => {


    const debounce = useDebounce();
    const queryClient = useQueryClient() 
    const { view, cambiarObservacion, observacionCotizacion } = useGlobalValueStore();
    const { precioUnidadSegunRol, precioTotalSegunRol } = usePrecioCarritoXRole();
    const [items, setItems] = useState(data || []);



    useEffect(() => {
        setItems(data || []);
    }, [data]);
    


    const handleModificarPrecioItem = useCallback((item, value) => {
        if( !value || value.trim() === '' ) return;
        
        setItems(prev => prev.map(c => c.id === item.id ? { ...c, precio: value } : c));
        debounce(async() => {
            const resp = await editarValorItemCarrito({ ...item, value, view });
            if( resp ) { queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });}
        }, 1000);

    }, [debounce, view]);



    const cambiarNombreProduc = useCallback((e, id) => {
        const nuevoNombre = e.target.value;
        if (!nuevoNombre || nuevoNombre.trim() === '') return;

        setItems(prev => prev.map(c => c.id === id ? { ...c, nombreModificado: nuevoNombre } : c));
        debounce(async () => {
            const resp = await modificarNombreCotizacion({ id, value: nuevoNombre });
            if(resp) { queryClient.invalidateQueries({ queryKey: ['carritoxuser'] }) }
        }, 1000);
    }, [debounce]);



    const handleObservacion = useCallback((e, id) => {
        const nuevaObservacion = e.target.value;
        if (!nuevaObservacion || nuevaObservacion.trim() === '') return;
        cambiarObservacion(nuevaObservacion)
    }, [debounce]);





    return (

        <>
        {items.map( car => (
            <TableRow key={ car.id }>
                <TableCell padding="checkbox">
                    <Checkbox 
                        color="primary" 
                        checked={selected.some( (item) => item === car.id )} 
                        onClick={ () => handleClick(car.id)}
                    />
                </TableCell>

                <TableCell sx={{ display:'flex', justifyContent:'center' }}>
                    <Avatar
                        alt="Imagen de Producto"
                        src={`${ baseUrl }/uploads/productos/${ car.producto.img }`} 
                        sx={{ width: 50, height: 50 }}
                    /> 
                </TableCell>

                <TableCell className="w-300">
                    <Box>
                        <TextFormField
                            sx={{ width: '100%' }}
                            size="small"
                            multiline
                            value={car.nombreModificado || car.producto.nombre}
                            onChange={(e) => cambiarNombreProduc(e, car.id)} 
                            onClick={(e) => e.stopPropagation()}
                        />
                    </Box>
                </TableCell>
                <TableCell>{ car.cantidad }</TableCell>

                <TableCell>{`$${separadorMillares(precioUnidadSegunRol(car) / car.cantidad)}`}</TableCell>

                <TableCell> 
                    <TextFormNumber
                        size="small"
                        value={ car.precio || precioUnidadSegunRol(car) }
                        onChange={(e) => handleModificarPrecioItem(car, e.target.value)}
                        inputProps={{ style: { padding:'1px', textAlign:'center', width:'80px' }}}
                    />
                </TableCell>
            </TableRow>
        ))}

        <TableRow>
            <TableCell colSpan={3} sx={{py:2}}><Typography sx={{fontSize:17, fontWeight:'bold'}}>TOTAL: </Typography></TableCell>
            <TableCell colSpan={3} sx={{py:2, fontSize:17, fontWeight:'bold'}}>
                {`$${separadorMillares(precioTotalSegunRol(data))}`}
            </TableCell>
        </TableRow>

        <TableRow>
            <TableCell colSpan={2} sx={{ fontWeight:800, fontSize:17 }}>
                Nota:
            </TableCell>

            <TableCell colSpan={4}>
                <TextField
                    name="observacion"
                    value={observacionCotizacion}
                    onChange={handleObservacion}
                    variant="standard"
                    size="small"
                    placeholder="¿Alguna observación?"
                    multiline
                    fullWidth
                    sx={{py: 2}}
                />
            </TableCell>

        </TableRow>
        </>
    )
}
